import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import { ThumbsUp, ThumbsDown } from "@phosphor-icons/react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { VideoCamera, Image, SpeakerHigh } from "@phosphor-icons/react";
import { API } from '../api/apiList';
import Axios from '../config/AxiosConfig';
import { getActiveLang, withLang } from '../utils/language';
import { Scrollbar } from 'react-scrollbars-custom';
import { Spinner } from 'react-bootstrap';

function Faq() {

    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [selectedFAQ, setSelectedFAQ] = useState(null);
    const handleClose = () => setShow(false);
    const handleShow = (faq) => {
        setSelectedFAQ(faq);
        setShow(true);
    };
    let APIDetails = API.find((API) => API.name === 'faq');
    const [listData, setListData] = useState([]);
    const selectedLanguage = getActiveLang();

    const settings = {
        customPaging: function (i) {
            const attachment = selectedFAQ?.attachments[i];
            let icon;
            switch (attachment?.file_type) {
                case 'video':
                    icon = <VideoCamera size={32} />;
                    break;
                case 'image':
                    icon = <Image size={32} />;
                    break;
                case 'audio':
                    icon = <SpeakerHigh size={32} />;
                    break;
                default:
                    icon = null;
            }
            return (
                <div className="attachment-thumbnail">
                    {icon}
                </div>
            );
        },
        appendDots: dots => <ul>{dots}</ul>,
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        arrows: false,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const renderAttachment = (attachment) => {
        switch (attachment.file_type) {
            case 'video':
                return (
                    <div className='faq-video'>
                        <video controls src={attachment.filename} />
                    </div>
                );
            case 'image':
                return (
                    <div className='faq-img'>
                        <img src={attachment.filename} />
                    </div>
                );
            case 'audio':
                return (
                    <div className='faq-audio'>
                        <audio controls src={attachment.filename} />
                    </div>
                );
            default:
                return null;
        }
    };

    useEffect(() => {
        FAQList();
    }, []);

    const FAQList = async () => {
        try {
            const response = await Axios.get(APIDetails.listAPI);
            if (response.data && response.data.success == 1) {
                setListData(response.data.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='innerPages'>
                <Container>
                    <Row>
                        <Col sm={12}>
                            <h2>{selectedLanguage === 'ori' ? "ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ" : "FAQs"}</h2>
                            <ul>
                                <li><Link to={withLang("/")}>{selectedLanguage === 'ori' ? "ହୋମ୍" : "Home"}</Link></li>
                                <li>/</li>
                                <li><strong>{selectedLanguage === 'ori' ? "ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ" : "FAQs"}</strong></li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className='aboutSection innerBg'>
                <Container>
                    <Row>
                        <Col sm={12}>
                            {loading ? (
                                <div className="d-flex justify-content-center">
                                    <Spinner animation="border" variant="success" />
                                </div>
                            ) : listData && listData.length > 0 ? (
                                <Accordion defaultActiveKey="0">
                                    {listData.map((faq, faqIndex) => (
                                        <Accordion.Item
                                            eventKey={faqIndex.toString()}
                                            key={faqIndex}
                                        >
                                            <Accordion.Header>
                                                <div dangerouslySetInnerHTML={{ __html: faq?.title }} />
                                            </Accordion.Header>
                                            <Accordion.Body className='btnAccordiom'>
                                                {faq?.answer?.length > 500 ? (
                                                    <>
                                                        <div dangerouslySetInnerHTML={{ __html: faq?.answer.substring(0, 500) + "....." }} />
                                                    </>
                                                ) : (
                                                    <div dangerouslySetInnerHTML={{ __html: faq?.answer }} />
                                                )}
                                                <div className="d-flex justify-content-end mt-3">
                                                    <Button
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        className='default-dislike'
                                                    >
                                                        <ThumbsDown size={18} weight="fill" />
                                                        {faq?.is_helpful_0_count}
                                                    </Button>
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        className='default-like'
                                                    >
                                                        <ThumbsUp size={18} weight="fill" />
                                                        {faq?.is_helpful_1_count}
                                                    </Button>
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={() => handleShow(faq)}>
                                                        Show Details
                                                    </Button>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            ) : null}
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal className='videoSlider' show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className={`${selectedFAQ?.attachments?.length === 0 ? "marign-top-faq" : ""}`}>
                    {selectedFAQ && (
                        <>
                            {selectedFAQ.attachments && selectedFAQ.attachments.length > 0 && (
                                <div className={`slider-container1 faqSlider ${selectedFAQ.attachments.length === 1 ? "" : "pb-4"}`}>
                                    {selectedFAQ.attachments.length === 1 ? (
                                        <div className="single-attachment">
                                            {renderAttachment(selectedFAQ.attachments[0])}
                                        </div>
                                    ) : (
                                        <Slider {...settings}>
                                            {selectedFAQ.attachments.map((attachment, index) => (
                                                <div key={index}>
                                                    {renderAttachment(attachment)}
                                                </div>
                                            ))}
                                        </Slider>
                                    )}
                                </div>
                            )}
                            <h2>{selectedFAQ.title}</h2>
                            {selectedFAQ?.answer?.length > 500 ?
                                <Scrollbar style={{ width: "auto", height: 90 }}>
                                    <p>{selectedFAQ.answer}</p>
                                </Scrollbar>
                                : <p>{selectedFAQ.answer}</p>
                            }
                            <div className="d-flex justify-content-end mt-3 btnAccordiom">
                                <Button variant="outline-secondary" className='default-dislike' size="sm">
                                    <ThumbsDown size={18} weight="fill" />
                                    {selectedFAQ.is_helpful_0_count}
                                </Button>

                                <Button variant="outline-primary" className='default-like' size="sm">
                                    <ThumbsUp size={18} weight="fill" />
                                    {selectedFAQ.is_helpful_1_count}
                                </Button>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Faq;